import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfviewerpageComponent } from './pdfviewerpage.component';
import { RouterModule, Routes } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BrowserModule } from '@angular/platform-browser';


const routes: Routes = [
  {
      path: '',
      component: PdfviewerpageComponent,
      data: {
          title: 'Pdf Viewer'
      }
  }
];
@NgModule({
  declarations: [PdfviewerpageComponent],
  imports: [
    BrowserModule,
    PdfViewerModule,
    CommonModule,    
    RouterModule.forChild(routes)
  ]
})
export class PdfviewerpageModule { }


